<template>
        <div>
	        <form @submit="formSubmit" enctype="multipart/form-data">
            <input class="input" type="hidden" v-model="fdata.id" >
			<input class="input" type="hidden" v-model="employee_id" >
			<input class="input" type="hidden" v-model="fiscal_year" >
			<input class="input" type="hidden" v-model="from_date" >
			<input class="input" type="hidden" v-model="to_date" >
			<input class="input" type="hidden" v-model="pay_slip_ref" >
			<input class="input" type="hidden" v-model="pay_slip_name" >
            <div class="row">
			  <div class="col-md-12 text-center"><p style="font-weight: bold; font-size: larger;margin-bottom: 0;">{{company_name}}</p><p> <span style="font-weight: bold;">{{payslip_title}}</span><br />Income Year {{fiscal_year}}</p></div>
			</div>
            <div class="row">
			  <div class="col-md-12">
                 <table class="table table-bordered table-hover table-sm">
                  <tr>
                  <td class="font-weight-bold">Employee ID</td>
                  <td>{{salaryheads.employee_code}}</td>
                  <td class="font-weight-bold">e-TIN No.</td>
                  <td>{{salaryheads.etin}}</td>
                  </tr>
                  <tr>
                  <td class="font-weight-bold">Job Position</td>
                  <td>{{salaryheads.jobposition}}</td>
                  <td class="font-weight-bold">Department</td>
                  <td>{{salaryheads.department}}</td>
                  </tr>
                  <tr>
                  <td class="font-weight-bold">Date of Joining</td>
                  <td>{{salaryheads.doj}}</td>
                  <td class="font-weight-bold">Branch</td>
                  <td>{{salaryheads.branch_name}}</td>
                  </tr>
				  <tr>
                  <td class="font-weight-bold">PF Start Date</td>
                  <td>{{salaryheads.pf_start_date}}</td>
                  <td class="font-weight-bold">Service Period</td>
                  <td>{{salaryheads.service_preiod}}</td>
                  </tr>
				  <tr>
                  <td class="font-weight-bold">PF Leave Date</td>
                  <td>{{salaryheads.pf_leave_date}}</td>
                  <td class="font-weight-bold">Membership Period</td>
                  <td>{{salaryheads.membership_period}}</td>
                  </tr>
                 </table>
              </div>
			</div>
            
			<div class="row">
			  <div class="col-md-12">
                
			    <table class="table">
			       <tbody> 
			            <tr class="table-head"><td>Monthly Report</td><td class="text-right">Amount(Taka)</td></tr>
                        <!--<tr class="table-row hover-bg"><td>Pay &amp; Allowances</td><td></td></tr>-->
			            <tr class="table-row hover-bg">
                           <td>Employer's Contribution</td><td  style="text-align: right;">{{moneyFormat(salaryheads.pf_contribution_employer)}}</td>
			            </tr>
						<tr class="table-row hover-bg">
							<td>Employee's Contribution</td><td  style="text-align: right;">{{moneyFormat(salaryheads.pf_contribution_employee)}}</td>
					 	</tr>
                        <tr class="table-head">
							<td>Total</td><td style="text-align: right;">{{moneyFormat(salaryheads.total_pf_contribution)}}</td>
						</tr>
		           </tbody>
		       </table>

			   <table class="table">
			       <tbody> 
			            <tr class="table-head"><td>PF Balance (on employer's contribution)</td><td class="text-right">Amount(Taka)</td></tr>
                        <!--<tr class="table-row hover-bg"><td>Pay &amp; Allowances</td><td></td></tr>-->
			            <tr class="table-row hover-bg">
                           <td>Contribution</td><td  style="text-align: right;">{{moneyFormat(salaryheads.contribution_balance_employer)}}</td>
			            </tr>
						<tr class="table-row hover-bg">
							<td>Profit Distribution</td><td  style="text-align: right;">{{moneyFormat(salaryheads.profit_balance_employer)}}</td>
					 	</tr>
						<tr class="table-row hover-bg">
							<td>Forfeiture</td><td  style="text-align: right;">{{moneyFormat(salaryheads.forfeiture_balance_employer)}}</td>
					 	</tr>
                        <tr class="table-head">
							<td>Total</td><td style="text-align: right;">{{moneyFormat(salaryheads.balance_total_employer)}}</td>
						</tr>
		           </tbody>
		       </table>

			   <table class="table">
			       <tbody> 
			            <tr class="table-head"><td>PF Balance (on employee's contribution)</td><td class="text-right">Amount(Taka)</td></tr>
                        <!--<tr class="table-row hover-bg"><td>Pay &amp; Allowances</td><td></td></tr>-->
			            <tr class="table-row hover-bg">
                           <td>Contribution</td><td  style="text-align: right;">{{moneyFormat(salaryheads.contribution_balance_employee)}}</td>
			            </tr>
						<tr class="table-row hover-bg">
							<td>Profit Distribution</td><td  style="text-align: right;">{{moneyFormat(salaryheads.profit_balance_employee)}}</td>
					 	</tr>
						<tr class="table-row hover-bg">
							<td>Forfeiture</td><td  style="text-align: right;">{{moneyFormat(salaryheads.forfeiture_balance_employee)}}</td>
					 	</tr>
                        <tr class="table-head">
							<td>Total</td><td style="text-align: right;">{{moneyFormat(salaryheads.balance_total_employee)}}</td>
						</tr>
		           </tbody>
		       </table>

			   <table class="table">
			       <tbody> 
			            <tr class="table-head"><td>PF Loan Balance</td><td class="text-right">Amount(Taka)</td></tr>
                        <!--<tr class="table-row hover-bg"><td>Pay &amp; Allowances</td><td></td></tr>-->
			            <tr class="table-row hover-bg">
                           <td>Opening Balance</td><td  style="text-align: right;">{{moneyFormat(salaryheads.pf_loan_opening_balance)}}</td>
			            </tr>
						<tr class="table-row hover-bg">
							<td>Adjustments during the month</td><td  style="text-align: right;">{{moneyFormat(salaryheads.pf_loan_monthly_adjustment)}}</td>
					 	</tr>
						<tr class="table-row hover-bg">
							<td>Closing Balance</td><td  style="text-align: right;">{{moneyFormat(salaryheads.pf_loan_closing_balance)}}</td>
					 	</tr>
                        
		           </tbody>
		       </table>

			   </div>
		 </div>	
				
          
          <div class="row mt-2">
			  <div class="col-md-12">
               <p class="mt-5 mb-5 text-center">**Computer generated pay slip does not require signature**</p>
              </div>
           </div>
           <div class="row mt-2">
            <div class="col-md-3 text-right"></div>
              <div class="col-md-4 text-right"><img v-if="action_loader" :src="$api_url+'/public/images/download-loader.gif'" class="w-25"/></div>
			  <div class="col-md-5">
              <!--<b-overlay :show="action_loader" rounded="sm">-->
                  <b-button class="border rounded bg-light float-right py-1 px-2 mt-4 ml-2" type="submit" variant="primary" @click="emailTaxCards(payslip)"><i class="far fa-envelope px-1" aria-hidden="true" style="font-size:16px;"></i> Email</b-button>
                  <b-button class="border rounded bg-light float-right py-1 px-2 mt-4 ml-2" type="submit" variant="primary" @click="downloadPaySlip(payslip,fiscal_year)"><i class="far fa-file-pdf px-1" aria-hidden="true" style="font-size:16px;"></i> Download PDF</b-button>
              <!--</b-overlay>-->
              </div>
           </div>
           </form>
        </div>	
</template>
<style scoped>
.s-thead{background: #c9c9c9;}
.s-tfoot{background: #e5e5e5;}
.s-section{background: #5b6992;}
</style>

  <script>
	  export default {
		  mounted() {
			 // console.log('Payslip started..');   
			 // console.log(this.componentdata);  
		  },
		  props: ['pageurl', 'payslip','company','payslipname','emp_etin','emp_department','emp_jobposition','emp_code','emp_joining','emp_branch'],
		  data() {
			  
			  return {
			  	total_other:0.0, //at_edit
			  	contribution: 0.0, //at-edit 9 nov 21
			  	deduction: 0.0, //at-edit 9 nov 21
				gross_salary: 0.0, //at-edit 9 nov 21
			      employees : [],
			      salaryheads : [], 
				  taxinfo : [],
                  taxdata : [],
				  fiscalyears: [],
				  adhocfields: [],
				  adhocheadsnvalues: [],
				  slabs_and_values : [],
				  fdata: [],  
				  pgurl:this.$api_url,
                  company_name:this.company,
                  payslip_title: this.payslipname,
                  download_file_name: '',
				  success: '',
				  employee_id: '',
				  fiscal_year: '',
				  from_date: '',
				  to_date: '',
				  pay_slip_ref: '',
				  pay_slip_name: '',
				  month: '',
				  year: '',
				  adhoc_field: '',
				  adhoc_field_value: '',
                  action_loader: false, 
                  decimal_setting: '',
                  pre_gross_flag: 0,
			  }
		  },
		  
		  methods:{
			  setSearch: function(pageflg)
			  {
				this.getSalaryinfo(); 
			  },
              moneyFormat(amount)
              {
                var money = Number(amount);
                money = money.toLocaleString();
                if(money=='NaN')
                    money = amount;
                else
                    if(this.decimal_setting == 'yes' || this.decimal_setting == ''){
                        if(money.indexOf(".")<0)
                            money = money+'.00';
                    }else{
                        money = money;
                    }
                return money;
              },
              
              getInwords: function(txt)
			  {
			     
                 
						  axios.get(this.$api_url+'/getinwords/'+txt , {
							  params: {
								  page: 1,
								  per_page: 10,
								  search_query: this.search,
								  search_query_by_id: '',
							  }
					  }).then(function(response){
					   
					  return response.data;
  
  
				  }.bind(this));
  
						  
			  },
              
              
			  getFiscalyears: function()
			  {
  
						  axios.get(this.$api_url+'/getfiscalyears' , {
							  params: {
								  page: 1,
								  per_page: 10,
								  search_query: this.search,
								  search_query_by_id: '',
							  }
					  }).then(function(response){
					  this.fiscalyears = response.data;
  
  
				  }.bind(this));
			  },
              
              getSalaryinfo: function()
			  {
						  axios.get(this.$api_url+'/pf-slip/'+this.employee_id , {
							  params: {
								  fiscal_year: this.fiscal_year,
								  payslip_id: this.fdata.id,
                                  output_type: 'merge_report',
								  search_query_by_id: '',
							  }
					  }).then(function(response){
					  this.salaryheads = response.data;
          
					  let y=0;
					  let z=0;

					  let slary_flag =0;
					  let contribution =0;
					  let off_cycle_adhocs =0;
					  let deduction = 0.0;
					  let arrear = 0.0;
					  let artar = 0.0;
					  
			
                    	/* at_edit  ends*/
                    
				  }.bind(this));
			  },
             getPayslipInfo: function()
             {

                   axios.get(this.$api_url+'/payslipinfo/'+this.payslip, {
                            params: {
                            }
                    }).then(function(response){
                    this.fdata = response.data.data;
                    this.employee_id = this.fdata.employee_id;
                    if(this.fdata.id!='')
            		  {
            		   this.fiscal_year=this.fdata.fiscal_year;
            		   this.employee_id=this.fdata.employee_id;
            		   this.from_date=this.fdata.from_date;
            		   this.to_date=this.fdata.to_date;
            		   this.pay_slip_ref=this.fdata.pay_slip_ref;
            		   
            		   this.setSearch();
            		   this.pay_slip_name=this.fdata.pay_slip_name;
            		  
            		  }
                }.bind(this));
             },
           download_file(fileURL, fileName) {
            if (!window.ActiveXObject) {
                var save = document.createElement('a');
                save.href = fileURL;
                save.target = '_blank';
                var filename = fileURL.substring(fileURL.lastIndexOf('/')+1);
                save.download = fileName || filename;
        	       if ( navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
        				document.location = save.href; 
        			}else{
        		        var evt = new MouseEvent('click', {
        		            'view': window,
        		            'bubbles': true,
        		            'cancelable': false
        		        });
        		        save.dispatchEvent(evt);
        		        (window.URL || window.webkitURL).revokeObjectURL(save.href);
        			}	
            }
            else if ( !! window.ActiveXObject && document.execCommand)     {
                var _window = window.open(fileURL, '_blank');
                _window.document.close();
                _window.document.execCommand('SaveAs', true, fileName || fileURL)
                _window.close();
            }
           },
             
           downloadPaySlip: function(p_slip,f_year,email_file=false,prnt_file=false)
			  {
				     this.action_loader = true; 
                     var send_file = email_file ? 1: 0;
                     axios.get(this.$api_url+'/payslippdf/'+f_year+'/'+p_slip , {
							  params: {
							     em_file:  send_file,
								 pf_slip:  1 
							  }
					  }).then(function(response){
					   
                      this.action_loader = false;
					  if(response.data.file_name){
				   
                      if(response.data.download_name) 
                      this.download_file_name = response.data.download_name;
                      else
                      this.download_file_name = this.payslip_title;
                       
                       
				      if(prnt_file)
                      this.download_file(response.data.file_name,this.download_file_name+'.pdf');
                      else if(email_file){
                        if(response.data.success)
                        this.$bvToast.toast(response.data.success, {
                                           title: 'Success',
                                            variant: 'success',
                                            solid: true
                                        });
                        else if(response.data.error)
                        this.$bvToast.toast(response.data.error, {
                                           title: 'Error!',
                                            variant: 'danger',
                                            solid: true
                                        });
                      }
                      else
                      this.download_file(response.data.file_name,this.download_file_name+'.pdf');
                      }
                      else if(response.data.error){
                        this.$bvToast.toast(response.data.error, {
                                           title: 'Error!',
                                            variant: 'danger',
                                            solid: true
                                        });
                      }else{
                        this.$bvToast.toast('Unexpected server error!', {
                                           title: 'Error!',
                                            variant: 'danger',
                                            solid: true
                                        });
                      }
                      //console.log(response.data.file_name);
				  }.bind(this));
		     }, 
             formSubmit(e) {
				  e.preventDefault();
				  let currentObj = this;
                  const config = {
					  headers: { 'content-type': 'multipart/form-data' }
				   }
				   let formData = new FormData(); 
				   formData.append('employee_id', this.employee_id);
				   formData.append('pay_slip_ref', this.pay_slip_ref);
				   formData.append('pay_slip_name', this.pay_slip_name);
				   formData.append('month', this.month);
				   formData.append('year', this.year);
				   formData.append('from_date', this.from_date);
				   formData.append('to_date', this.to_date);
				   formData.append('fiscal_year', this.fiscal_year); 
				   if(this.adhoc_field!='')
				   formData.append('adhoc_field', this.adhoc_field);
				   if(this.adhoc_field_value!='')
				   formData.append('adhoc_field_value', this.adhoc_field_value);
				   axios.post(this.$api_url+'/payslip-action-vue', formData, config)
				   .then(function (response) {
                      currentObj.getSalaryinfo();
					  currentObj.success = response.data.success;
					  currentObj.fdata.id = response.data.payslip_id;
					  currentObj.adhoc_field_value="";
					  currentObj.adhoc_field="";
					  currentObj.hideAdhoc();
				  })
				  .catch(function (error) {
					  currentObj.output = error;
				  });
			  },
              
              emailTaxCards: function(taxcard)
              {
                  this.action_loader = true;
                  const config = {
					  headers: { 'content-type': 'multipart/form-data' }
				  }
                  let formData = new FormData();
                  formData.append('payslipids', taxcard);
                  formData.append('modification_flag', '3');
  
				  axios.post(this.$api_url+'/modifypayslips', formData, config)
  
				  .then(function (response) {
				    this.action_loader = false;

                    if(response.data.success)
                        this.$bvToast.toast(response.data.success, {
                                           title: 'Success',
                                            variant: 'success',
                                            solid: true
                                        });
                    

  
				  }.bind(this));
              },
              get_decimal_settings: function()
              {
                  axios.get(this.$api_url+'/decimal-settings')
                
                  .then(function (response) {
                    this.decimal_setting = response.data;  
                  }.bind(this));
              },
		  },
		  created: function(){
		     this.getPayslipInfo();
			 this.getFiscalyears(); 
             this.get_decimal_settings();	
		  }
	  }
  </script>